import { api } from '../api';
import { urls } from 'api/urls';

const getCep = async (cep: string) => await api.get(`${urls.cep}/${cep}`);

export { getCep };
